export const DocumentUsageTypes = {
    customer: 'Customer',
    broker: 'Broker',
    driver: 'Driver',
    driverLoad: 'DriverLoad',
};
